import React, { useMemo, useState } from "react";
import SEO from "../components/SEO";
import useCasesData from "../data/useCases.json";
import { NavLink } from "react-router-dom";
import { logActivity } from "../utils/activity";

export default function UseCases() {
  const defaultCase =
    useCasesData.cases.find((item) =>
      item.title.toLowerCase().includes("consultant")
    ) || useCasesData.cases[0];
  const [active, setActive] = useState(defaultCase);
  const steps = useMemo(() => {
    if (!active?.description) return [];
    const base = active.description.replace(/\.$/, "");
    const parts = base.split(/,| and /).map((part) => part.trim());
    const filtered = parts.filter(Boolean);
    return filtered.length ? filtered.slice(0, 3) : [base];
  }, [active]);

  return (
    <div className="bg-slate-50">
      <SEO
        title={useCasesData.seo?.title}
        description={useCasesData.seo?.description}
        ogType="website"
        ogImage={useCasesData.seo?.ogImage}
      />
      <section className="section-padding mx-auto w-full max-w-6xl">
        {/* <!-- Replace with dynamic content from JSON --> */}
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          {useCasesData.eyebrow}
        </p>
        <h1 className="page-title mt-3">{useCasesData.title}</h1>
        <p className="mt-4 text-lg text-slate-600">
          {useCasesData.subtitle}
        </p>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto grid w-full max-w-6xl gap-8 md:grid-cols-[0.8fr_1.2fr]">
          <div className="space-y-3">
            {/* <!-- Replace with dynamic content from JSON --> */}
            {useCasesData.cases.map((item) => (
              <button
                key={item.title}
                type="button"
                onClick={() => setActive(item)}
                className={`card flex w-full items-start gap-4 p-5 text-left transition ${
                  active.title === item.title
                    ? "border-amber-500 text-slate-900 shadow-md"
                    : "text-slate-600 hover:border-amber-300"
                }`}
              >
                <div className="text-2xl">{item.icon}</div>
                <div>
                  <p className="text-base font-semibold text-slate-900">
                    {item.title}
                  </p>
                  <p className="mt-1 text-sm text-slate-600">
                    {item.description}
                  </p>
                </div>
              </button>
            ))}
          </div>

          <div className="space-y-4">
            <div className="card p-6">
              <p className="text-sm text-slate-600">{active.description}</p>
            </div>
            <div className="card p-6">
              <ul className="space-y-2 text-sm text-slate-600">
                {steps.map((step) => (
                  <li key={step} className="flex items-start gap-2">
                    <span className="mt-1 h-1.5 w-1.5 rounded-full bg-amber-500" />
                    {step}
                  </li>
                ))}
              </ul>
            </div>
            <div className="card p-6">
              <p className="text-sm text-slate-600">{useCasesData.subtitle}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="card mx-auto flex w-full max-w-6xl flex-col items-start justify-between gap-6 px-6 py-10 md:flex-row md:items-center md:px-10">
          <div>
            <h2 className="text-2xl font-semibold text-slate-900">
              {useCasesData.cta.title}
            </h2>
            <p className="mt-2 text-sm text-slate-600">
              {useCasesData.cta.subtitle}
            </p>
          </div>
          <NavLink
            to="/pricing"
            className="btn btn-primary"
            onClick={() =>
            logActivity("internal_link", { from: "use-cases", to: "pricing" })
            }
          >
            {useCasesData.cta.label}
          </NavLink>
        </div>
      </section>
    </div>
  );
}
